export default "__VITE_PUBLIC_ASSET__6339c362__"